import { supabasePublic, supabaseSchema } from "../components/supabaseClient";

/**
 * `settings` JSON for the current tenant from public.schema_settings.
 * Same data source as AdminPage.sendForms (fetchUserSettings) — no toasts, no auto-insert.
 */
export async function fetchCurrentSchemaSettings() {
  const { data, error } = await supabasePublic()
    .from("schema_settings")
    .select("settings")
    .eq("schema_name", supabaseSchema)
    .single();

  if (error) {
    return {};
  }
  return data?.settings || {};
}
